import { render, staticRenderFns } from "./CatalogSort.vue?vue&type=template&id=649d9f5a&scoped=true&"
import script from "./CatalogSort.vue?vue&type=script&lang=js&"
export * from "./CatalogSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649d9f5a",
  null
  
)

export default component.exports